import { warn as _warn } from "@instructure/console";

function getElementType(Component, props, getDefault) {
  if (props.as && props.as !== Component.defaultProps.as) {
    return props.as;
  }

  if (typeof getDefault === 'function') {
    return getDefault();
  }

  if (props.href) {
    return 'a';
  }

  if (props.to) {
    /*#__PURE__*/

    /*#__PURE__*/
    _warn( // if to prop is used without as
    !props.as, "[".concat(Component.displayName, "] `as` prop should be provided when using `to`"));

    return 'a';
  }

  if (typeof props.onClick === 'function') {
    return 'button';
  }

  return Component.defaultProps.as || 'span';
}

export default getElementType;
export { getElementType };